import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { isEmpty } from 'lodash';
import Switch from 'react-switch';
import {
  Alert,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Col,
  FormGroup,
  Row
} from 'reactstrap';
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import TabNav from '../managed-product/section/TabNav';
import LoaderButton from '../loader-button/LoaderButton';
// import FalconCardHeader from '../common/FalconCardHeader';
import CredsModal from '../managed-product/Vendor/CredsModal';
// services
import BZAPIService from '../../services/BZAPIService';
//libs
import { useFormFields } from '../../libs/hooksLib';
import { FieldGroup } from '../../libs/formLib';
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// constants
import SETTINGS from '../../constants/settings';
import Heading from '../common/Heading';
import ButtonIcon from '../common/ButtonIcon';
import Loader from '../common/Loader';
// import Divider from '../common/Divider';

const ConfigServiceNow = () => {
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [Ip, setIp] = useState('');
  const [fields, handleFieldChange] = useFormFields({
    snApiUrl: '',
    secretId: '',
    user: '',
    pass: ''
  });
  const [shareBugClosureData, setshareBugClosureData] = useState(true);
  // const [snIntegrationCheck, setSnIntegrationCheck] = useState(false);
  const [snIntegrationTest, setSnIntegrationTest] = useState({});

  const [activeTab, setActiveTab] = useState('1');

  const navigate = useNavigate();
  useEffect(() => {
    async function onLoad() {
      try {
        // Set Managed product if exists
        let settings = await BZAPIService.getSetting(SETTINGS.SERVICE_NOW);
        console.log('settings: ', settings);
        let publicIP = await BZAPIService.getPublicIP();
        const myUserPermissions = await BZAPIService.getMyUserPermissions();
        console.log('myUserPermissions', myUserPermissions);
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));
        console.log('adminIsReadOnlyCheck(myUserPermissions)', adminIsReadOnlyCheck(myUserPermissions));

        if (!settings)
          settings = {
            secretId: '',
            snApiUrl: '',
            snAuthToken: '',
            shareBugClosureData: 1
          };
        fields.secretId = settings.secretId;
        fields.snApiUrl = settings.snApiUrl;
        if (!settings.shareBugClosureData) settings.shareBugClosureData = 1;
        setshareBugClosureData(settings.shareBugClosureData === 1 ? true : false);
        // console.log('publicip', publicIP);
        setIp(publicIP?.publicIp || 'IP not found.');
        // !settings || isEmpty(settings) ? setSnIntegrationCheck(false) : setSnIntegrationCheck(true);
        if (settings) {
          const snIntegrationTest = await BZAPIService.sNConectionTest();
          setSnIntegrationTest(snIntegrationTest);
        }
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    }

    onLoad();
  }, [fields.secretId]);
  async function saveAWSSecret() {
    const data = {
      secret: {
        user: fields.user,
        pass: fields.pass
      },
      vendorId: 'servicenow',
      key: 'snAuth'
    };
    // service api secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function saveConfig(secret) {
    const data = {
      secretId: secret.Name,
      snApiUrl: fields.snApiUrl,
      type: 'global',
      shareBugClosureData: shareBugClosureData === true ? 1 : 0
    };

    const syncOnly = false;

    return BZAPIService.saveSetting(SETTINGS.SERVICE_NOW, syncOnly, data);
  }
  async function handleSave() {
    try {
      // validate url
      const validUrl = fields.snApiUrl.match(
        /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
      );
      console.log('validUrl', validUrl);
      if (!validUrl) setIsValidUrl(false);
      else setIsValidUrl(true);
      setIsSubmitted(true);
      setIsLoading(true);
      // Validate
      if (!fields.snApiUrl || !validUrl) {
        setIsLoading(false);

        return;
      }

      // Validate Secrets
      if (!fields.secretId) {
        if (!fields.user || !fields.pass) {
          console.log('misisng secret');
          setIsLoading(false);
          return;
        }
      }

      let secret;

      if (fields.user && fields.pass) {
        // Updated secrets
        secret = await saveAWSSecret();
      } else {
        // use existing secrets
        secret = { Name: fields.secretId };
      }
      // console.log('secret', secret);
      if (!secret || !secret.Name) {
        setIsLoading(false);
        throw Error('Missing Secret');
      }

      await saveConfig(secret);
      setIsLoading(false);
      setIsSubmitted(false);
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
    // Go back to listing
  }

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const data = {
      user: fields.user,
      pass: fields.pass,
      snApiUrl: fields.snApiUrl
    };
    const result = await BZAPIService.integrationServiceNowTest(data);
    setIsTestingValidCredentials(false);
    if (result) {
      // valid creds
      if (!result.valid) {
        return toast.error(`Unable to validate ServiceNow credentials.`);
      }
      setIsValidCredentials(true);
      setIsAddingCredentials(false);
      toast.success(`ServiceNow credentials validated.`);
    } else {
      toast.error(`Unable to validate ServiceNow credentials.`);
    }

    // console.log('result', result);
  }

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const TabNav = () => {
    return (
      <Nav tabs className="nav-pills">
        <NavItem
          data-testid={'overview-tab'}
          className={`${
            activeTab === '1' ? 'bg-branding-gray shadow branding-blue' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '1' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('1');
            }}
          >
            {' '}
            Overview
          </NavLink>
        </NavItem>

        <NavItem
          data-testid={'default-config-tab'}
          className={`${
            activeTab === '2' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '2' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('2');
            }}
          >
            {' '}
            Whitelisting
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'filtering-tab'}
          className={`${
            activeTab === '3' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '3' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('3');
            }}
          >
            {' '}
            Credentials
          </NavLink>
        </NavItem>
        <NavItem
          data-testid={'filtering-tab'}
          className={`${
            activeTab === '4' ? 'bg-branding-gray shadow' : 'bg-branding-blue text-white'
          } btn btn-outline-blue mr-3`}
        >
          <NavLink
            className={`${activeTab === '4' ? 'branding-blue' : ''}`}
            onClick={() => {
              toggleTab('4');
            }}
          >
            {' '}
            Data sharing
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  if (isLoading && !isSubmitted) return <Loader />;
  return (
    <>
      <Heading
        title="ServiceNow Configuration"
        subtitle="Specify your ServiceNow configuration"
        className="mb-4 mt-3"
        icon="cog"
      />
      {isReadOnly && (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      )}

      <TabNav />
      {/* Tab 1 */}
      <TabContent>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="1">
            {activeTab === '1' ? (
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={6} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
                      <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
                        <CardBody className="position-relative">
                          <Row>
                            <Col>
                              <h6 className="dash-vendor-label">ServiceNow</h6>
                            </Col>
                            <Col className="text-right d-inline-flex flex-row-reverse">
                              <p className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} small`}>
                                <span className="pb-2">{snIntegrationTest?.valid ? 'OPERATIONAL' : 'ERROR'}</span>
                              </p>
                              <p className="small">
                                <span className="fa-stack fa-xs mr-1">
                                  <FontAwesomeIcon
                                    icon="circle"
                                    className={`branding-${snIntegrationTest?.valid ? 'green' : 'red'} fa-stack-2x`}
                                  />
                                  <FontAwesomeIcon
                                    icon={snIntegrationTest?.valid ? 'check' : 'exclamation'}
                                    className="fa-stack-1x"
                                    inverse
                                  />
                                </span>
                              </p>
                            </Col>
                          </Row>
                          {!snIntegrationTest?.valid ? (
                            <div>
                              <div className="col">
                                <div className="row">
                                  <Button
                                    color="falcon-default"
                                    className="btn btn-falcon-default mt-2"
                                    size="sm"
                                    onClick={() => {
                                      toggleTab('3');
                                    }}
                                  >
                                    Configure
                                  </Button>
                                </div>
                              </div>

                              <>
                                <div className="active">
                                  <small>{snIntegrationTest?.error?.message}</small>
                                </div>
                              </>
                            </div>
                          ) : (
                            <></>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        {/* Tab 2 */}
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="2">
            {activeTab === '2' ? (
              <Card className="mb-4">
                <CardBody>
                  <div className="col text-right">
                    <a
                      href="https://docs.servicenow.com/en-US/bundle/utah-platform-security/page/administer/login/task/t_AccessControl.html"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-falcon-default ml-2 btn-sm"
                    >
                      <FontAwesomeIcon icon="book" className="mr-2" />
                      Whitelisting Guide
                    </a>
                  </div>
                  <Col>
                    <p>
                      <strong className="text-bold mr-2">Source IP for Whitelisting:</strong>
                      <span className="branding-red" data-testid={'ip-whitelisting'}>
                        {Ip}
                      </span>
                    </p>
                  </Col>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        {/* Tab 3 */}
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="3">
            {activeTab === '3' ? (
              <Card className="mb-4">
                <CardBody className="fs--1">
                  <FormGroup lg="5">
                    <FieldGroup
                      type="text"
                      label="ServiceNow URL"
                      id="snApiUrl"
                      data-testid={'sn-url'}
                      onChange={handleFieldChange}
                      value={fields.snApiUrl}
                      placeholder="Enter URL"
                      // style={{ marginBottom: '10px' }}
                      help="E.g. https://company-name.service-now.com"
                      feedback="Please specify a valid url starting with http or https."
                      showFeedback={!isValidUrl && isSubmitted}
                    />
                  </FormGroup>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        {!isAddingCredentials ? (
                          <div className="d-flex align-items-center">
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(true)}
                              color="falcon-default"
                              size="sm"
                              disabled={!fields.snApiUrl}
                              icon="plus"
                              iconClassName="fs--2"
                              className="mr-2"
                              data-testid={'sn-set-credentials-btn'}
                            >
                              Set Credentials
                            </ButtonIcon>
                            {fields.secretId || isValidCredentials ? (
                              <div className="d-flex align-items-center" data-testid={'sn-creds-stored-message'}>
                                <FontAwesomeIcon icon={'check'} style={{ color: 'green' }} className="mr-1" />
                                ServiceNow API Credentials Stored
                              </div>
                            ) : null}
                          </div>
                        ) : (
                          <>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  label="ServiceNow API Credentials"
                                  id="user"
                                  data-testid={'sn-username-input'}
                                  onChange={handleFieldChange}
                                  value={fields.user}
                                  placeholder="Enter username"
                                  style={{ marginBottom: '10px' }}
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="password"
                                  label="&nbsp;"
                                  id="pass"
                                  data-testid={'sn-password-input'}
                                  placeholder="Enter password"
                                  onChange={handleFieldChange}
                                  value={fields.pass}
                                  help="We will auto-generate a token based off the credentials you
													enter."
                                />
                              </Col>
                            </Row>
                            <br />
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={'servicenow'}
                            />
                            <Button
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-danger"
                              data-testid={'sn-cancel-creds'}
                              // size="sm"
                              iconClassName="fs--2"
                              style={{ marginRight: '10px' }}
                            >
                              Cancel
                            </Button>
                          </>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
        <div style={{ minWidth: '100%' }}>
          <TabPane tabId="4">
            {activeTab === '4' ? (
              <Card className="mb-4">
                <CardBody>
                  <Col>
                    <p>
                      Choose whether or not you would like to anonymously share data from your ServiceNow instance to
                      further enhance bug risk scoring and help others avoid disruptions.
                    </p>
                    <Switch
                      id={'closure-share-switch'}
                      onChange={e => setshareBugClosureData(e)}
                      checked={shareBugClosureData}
                      data-testid={'bug-closure-share'}
                      uncheckedIcon={false}
                      onColor="#617E71"
                      height={14}
                      width={28}
                    />
                    <label className="ml-2 pb-1 ">Anonymously share bug data with BugZero's community</label>
                  </Col>
                </CardBody>
              </Card>
            ) : (
              <></>
            )}
          </TabPane>
        </div>
      </TabContent>

      <Row className="flex-between-center" style={{ marginTop: '40px' }}>
        <Col xs="auto">
          <Button
            block
            color="falcon-danger"
            data-testid={'cancel-btn'}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col xs="auto">
          <LoaderButton
            block
            color="falcon-primary"
            onClick={handleSave}
            name="save-and-add"
            isLoading={isLoading}
            disabled={isReadOnly}
          >
            Save changes
          </LoaderButton>
        </Col>
      </Row>
    </>
  );
};

export default ConfigServiceNow;
